import { CallLog } from '../../../call/call-log/call-log';
import { ConversationLog } from '../../../conversation/conversation-log/conversation-log';
import { CommunicationSessionId } from '../../../core/communication-session-id/communication-session-id';

export const getCommunicationSessionIdFrom = (communicationLog: CallLog | ConversationLog) =>
  communicationLog instanceof CallLog
    ? new CommunicationSessionId({ inboundCallSessionId: communicationLog.getId() })
    : new CommunicationSessionId({ conversationLogId: communicationLog.getId() });
